import { Backdrop, CircularProgress } from "@mui/material";

type AppLoadingOverlayProps = { visible: boolean };

const AppLoadingOverlay = ({ visible }: AppLoadingOverlayProps) => (
  <Backdrop open={visible} sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
    <CircularProgress color="inherit" />
  </Backdrop>
);

export default AppLoadingOverlay;
